import callApiPromise from "../../helpers/call-api-promise";

export const getCurrentPrepaidBalanceQuery = () =>
    callApiPromise({
        endpoint: "/user/prepaid/",
        method: "GET",
    })();

export const getSavedCreditCardQuery = () =>
    callApiPromise({
        endpoint: "/get/customer/",
        method: "GET",
    })();
